module.exports = __webpack_public_path__ + "media/packs/images/state/small/sea-fbd512f830155fac27d389c9e0d065c6.svg";